import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Returns_ModuleContextService } from './Returns.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Returns_shipping_container_return_states_dd_ComponentContextService {
  private readonly moduleContext: Returns_ModuleContextService;

  constructor(moduleContext: Returns_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'shipping_container_return_states_dd',
      type: ComponentType.selector
    }
  }
}